export default __webpack_public_path__ + "df993a7d9a9e14ddec090e5a3f2f461e.webp";